<script setup lang="ts">
import type { MenuOption } from "naive-ui"
import { NIcon } from "naive-ui"
import { AddBusinessOutlined, InsertLinkOutlined } from "@vicons/material"
import {
    ImagesOutline,
    DocumentTextOutline,
    ChatbubblesOutline,
    SettingsOutline,
} from "@vicons/ionicons5"

const route = useRoute()
const router = useRouter()

const value = computed(() => {
    return route.name as string
})

const collapsed = ref(false)

function renderIcon(icon: Component) {
    return () => h(NIcon, null, { default: () => h(icon) })
}

function onChangeValue(v: string) {
    router.push({ name: v })
}

const menuOptions: MenuOption[] = [
    {
        label: "租户列表",
        key: "config",
        icon: renderIcon(AddBusinessOutlined),
    },
    {
        label: "缺省页管理",
        key: "config-empty",
        icon: renderIcon(ImagesOutline),
    },
    {
        label: "素材图管理",
        key: "config-material",
        icon: renderIcon(ImagesOutline),
    },
    {
        label: "页面文案管理",
        key: "config-description",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: "跳转路径管理",
        key: "config-path",
        icon: renderIcon(InsertLinkOutlined),
    },
    {
        label: "订阅消息配置",
        key: "config-message",
        icon: renderIcon(ChatbubblesOutline),
    },
    {
        label: "系统配置",
        key: "config-main",
        icon: renderIcon(SettingsOutline),
    },
]
</script>

<template>
    <NLayoutSider
        bordered
        collapse-mode="width"
        :width="240"
        :collapsed="collapsed"
        show-trigger
        @collapse="collapsed = true"
        @expand="collapsed = false"
    >
        <NMenu
            accordion
            :value="value"
            :collapsed="collapsed"
            :options="menuOptions"
            @update:value="onChangeValue"
        />
    </NLayoutSider>
</template>
